import classNames from 'classnames';
import { Icon } from 'copilot-design-system';
import React from 'react';

type ErrorMessageProps = {
  message: string;
  hideIcon?: boolean;
  className?: string;
};

export const ErrorMessage = ({
  hideIcon,
  message,
  className,
}: ErrorMessageProps) => {
  return (
    <div className={classNames('text-error-primary', className)}>
      <span className="inline">
        {!hideIcon && (
          <Icon
            icon="Failed"
            className="inline align-middle h-3 w-3 mr-1 mb-0.5"
          />
        )}
        {message}
      </span>
    </div>
  );
};
